import { SignUpFormState } from "./Types";
import * as Yup from "yup";

export const SignUpValidationSchema = Yup.object<SignUpFormState>().shape({
	username: Yup
		.string()
		.min(3, 'Username must be at least 3 characters')
		.required('Required'),
	emailAddress: Yup
		.string()
		.email('Please enter a valid email address')
		.required('Required'),
	password: Yup
		.string()		
		.min(8, 'Password must be at least 8 characters')
		.max(25, 'Password must be less than 25 characters')
		.matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/, 'Password requires lower/upper case letters, number, and special character')
		.required('Required'),
	firstName: Yup
		.string()
		.max(25, 'First Name must be less than 25 characters'),
	lastName: Yup
		.string()
		.max(25, 'First Name must be less than 25 characters'),
	birthday: Yup
		.string()
});
